/**
 * Conditionally loads Apple Pay JS SDK if Apple Pay is an available funding option.
 * Enables third-party browser support (Chrome, Firefox on iOS with WebSocket).
 * SDK is loaded from Apple's CDN asynchronously.
 * 
 * @param fundingOptions - Array of available funding options (e.g., ['Card', 'ApplePay', 'GooglePay'])
 */
export const loadApplePaySDKIfNeeded = (fundingOptions?: string[]): void => {
  const sdkSrc = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

  // Only load if Apple Pay is in funding options
  if (!fundingOptions?.includes('ApplePay')) {
    return;
  }

  // Skip if SDK already loaded
  if (window.ApplePaySession) {
    return;
  }

  // Skip if SDK script is already present in DOM (prevents duplicate injection/race conditions)
  if (document.querySelector(`script[src="${sdkSrc}"]`)) {
    return;
  }

  // Load SDK from Apple's CDN
  const script = document.createElement('script');
  script.src = sdkSrc;
  script.async = true;
  script.onerror = () => {
    console.error('[Apple Pay] Failed to load SDK from Apple CDN');
  };
  document.head.appendChild(script);
};
